<template>
  <div>
     <Table :columns="columns10" :data="data9"> </Table>
      
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import {
  cmsWaringList,
  cmsCleanWaring,
  updateMachineStatus,
  videoOnline
} from "../../api/machine";
 
 
export default {
  components: { SingleUpload },
  data() {
    return {
      machineNumber: "",
      modal3: false,
      jiqitype: "3",
      fengmian: "", //封面图
      guize: "", //规则图
      roomlv: "", //房间等级
      jiqihao: "", //机器号
      duankouhao: "", //端口号
      roomname: "", //房间名称
      danjia: "", //单价
      jiangli: "", //奖励
      progress: "10", //询奖时间
      loading: true,
      modal1: false,
      xbid: "", //小板id
      xbsort: 1, //小板座位号
      clickmachineid: "",
      videourl1: "",
      timer: null,
      columns10: [
        {
          title: "机器号",
          key: "roomid",
        },
         
        {
          title: "名字",
          key: "name",
        },
        {
          title: "现在备注名",
          key: "broomname",
        },
        
        {
          title: "小板id",
          key: "videomachineid",
        },
        {
          title: "在线状态",
          key: "online",
        },
        
      ],
      current: 1,
      total: 0,
      data9: [],
    };
  },
  mounted() {
    this.selmachine();
    // Set up timer to call selmachine every 2 seconds
    this.timer = setInterval(() => {
      console.log("===");
      this.selmachine();
    }, 5000);
  },
  beforeDestroy() {
    // Clean up timer when component is destroyed
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    changePage(e) {
      this.current = e;
      this.selmachine(); // 直接调用查询函数，不用重复逻辑
    },
    selmachine() {
      console.log("===");

      videoOnline({  page: this.current}).then((response) => {
        console.log("===" + JSON.stringify(response));
        this.data9 = response.data; // 获取查询结果
        
      });
    },
    updateimage1(value) {
      this.fengmian = value;
      console.log("updateimage1" + value);
    },
    updateimage2(id) {
      
      cmsCleanWaring({
         cid: id,
      }).then((res) => {
        this.selmachine();
      });
    },
    ok() {
      cerCoinMachine({
        machineid: this.jiqihao,
        roomname: this.roomname,
        roomlv: this.roomlv,
        image: this.fengmian,
        rule: this.guize,
        price: this.danjia,
        reward: this.jiangli,
        progress: parseInt(this.progress),
        videourl1: this.videourl1,
        machinetype: this.jiqitype === "3" ? 3 : 4,
        sort: 0,
      })
        .then((res) => {
          this.modal1 = false;
          this.$Message.info("Clicked ok");
        })
        .catch((err) => {});
      //
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    waringReply(cid,reply){
 
      waringReply({
        cid: cid,
        reply:reply
      }).then((res) => {
      });
 
    },
    updateMachineStatus(status) {
     
      updateMachineStatus({
        status: status,
        roomid: this.clickmachineid,
        machineNumber: this.machineNumber,
      }).then((res) => {
        this.selmachine();
      });
    },
    guanbimodal() {
      this.modal3 = false;
    },
  },
};
</script>
